import { apiSimulacao } from "~services/utils/api";
import apiGenericClient from "~services/utils/apiGenericClient";

export const salvarNegociacao = async (data) => {

    const client = new apiGenericClient("simulacao", "/api/TabelaPreco")
    const response = await client.createData(data);

    return response.data === undefined ? response : response.data;
};

export const renovarNegociacao = async (data) => {
  const client = new apiGenericClient("simulacao", "/api/TabelaPreco/Renovar")
  const response = await client.createData(data);

  return response.data === undefined ? response : response.data;
};

export const excluirPreco = async (dados) => {
  const client = new apiGenericClient("simulacao", "/api/PortalAprovacao/DeletarPreco/")
  const response = await client.createData(dados);

  return response.data === undefined ? response : response.data;
};


export const getBeneficioFiscal = async (clienteId, filialId, produtoId) => {
  if (!clienteId || !filialId || !produtoId) return null;

  const res = await apiSimulacao.get(`/api/PortalAprovacao/BeneficioFiscal/${clienteId}/${filialId}/${produtoId}`).then((response) => {
    if (response.data === undefined) return response;
    return response.data;
  });
  return res;
};


export const getTabelaPrecoClienteById = async (clienteId) => {
  if (!clienteId || clienteId == 0) return null;

  const res = await apiSimulacao.get(`/api/TabelaPreco/TabelaPrecoCliente/${clienteId}`).then((response) => {
    if (response.data === undefined) return response;
    return response.data;
  });

  return res;
};